import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { AdminTopNav } from '@src/components/Admin/AdminTopNav';
import { ClaimsDownload } from '@src/components/Claims/ClaimsDownload';
import { EmployeeFilter } from '@src/components/EmployeeFilter';
import { compact } from 'lodash';
import { SearchFilterBar, useLocale } from 'pe-core-frontend';
import { useEffect, useState } from 'react';
export const ClaimsAdminTopNav = ({ tab, showFilter, filter, handleFilterChange, isSuperuser, actions, }) => {
    const { t } = useLocale();
    const [searchText, setSearchText] = useState(filter?.searchText || '');
    useEffect(() => {
        if (handleFilterChange) {
            handleFilterChange({
                ...filter,
                searchText,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchText]);
    const handleSearchChange = (searchValue) => {
        setSearchText(searchValue);
    };
    return (_jsx(AdminTopNav, { title: t('Claims'), navLinks: compact([
            {
                title: t('Pending claims'),
                path: '/admin/claims/pending',
                selected: tab === 'pending',
            },
            {
                title: t('Info requested claims'),
                path: '/admin/claims/info_requested',
                selected: tab === 'info_requested',
            },
            {
                title: t('On hold claims'),
                path: '/admin/claims/hold',
                selected: tab === 'hold',
            },
            {
                title: t('Processed claims'),
                path: '/admin/claims/processed',
                selected: tab === 'processed',
            },
            isSuperuser && {
                title: t('Config'),
                path: '/admin/claims/config',
                selected: tab === 'config',
            },
        ]), searchFilterActions: showFilter &&
            filter &&
            handleFilterChange && (_jsx(SearchFilterBar, { enableSearch: true, enableFilter: true, filterActions: _jsx(EmployeeFilter, { filter: filter, onFilterChange: handleFilterChange }), isFilterActive: !!(filter?.clientId || filter?.startDate || filter?.endDate), onSearchChange: handleSearchChange, searchText: filter?.searchText || '', searchPlaceholder: t('Search by Name or Request #') })), actions: _jsxs(_Fragment, { children: [actions, _jsx("div", { children: _jsx(ClaimsDownload, {}) })] }) }));
};
